<div id="<%= modal_window_id %>" class="modal" tabindex="-1" role="dialog">
	<%- include(template, template_data) %>
</div>
